// docs: https://github.com/altostra/type-validations#readme
import { anyOf, arrayOf, objectOf } from "@altostra/type-validations";
import { boolean, nullOrUndefined, number, string } from "@altostra/type-validations/lib/primitives";

const maybeNullString = anyOf(nullOrUndefined, string);
const isAnyObject = (val: unknown): val is Record<string, unknown> => typeof val === "object" && val !== null;
const maybeNullAttrs = anyOf(nullOrUndefined, isAnyObject);

const isCustomObjectsTypeNameExternalIdUsersResultItem = objectOf({
  id: string,
  user_id: string,
  external_id: maybeNullString,
  first_name: maybeNullString,
  last_name: maybeNullString,
  email: maybeNullString,
  phone: maybeNullString,
  role: maybeNullString,
  attrs: maybeNullAttrs,
});

export const isCustomObjectsTypeNameExternalIdUsersResult = objectOf({
  hits: number,
  results: arrayOf(isCustomObjectsTypeNameExternalIdUsersResultItem),
  is_at_users_per_object_limit: boolean,
  users_per_object_limit: number,
});
